import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';
import { isAccountOwner } from 'src/core/utils/entities/userTyped';

import { type Member } from '../../../member';

export const useMembersQuery = (): QueryState<Member[]> => {
  const companyId = useCompanyId();

  return useQuery<Member[]>({
    key: 'members',
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/users?includePending=true',
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reshapeData(data: any[]) {
      return data.map((member) => {
        return {
          id: member.id,
          fullname: member.fullname,
          email: member.email,
          avatar: member.avatar,
          isPending: member.pending,
          isAccountOwner: isAccountOwner(member, { id: companyId }),
        };
      });
    },
  });
};
